import { React, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { Dropdown } from "antd";
import { UserContext } from "../App";
import "../styles/Header.css";
import { ReactComponent as Logo } from "../images/logo.svg";
import jobHubimg from "../images/JobHub2.png";
import { Avatar } from "@mui/material";
import {
  Home,
  Person,
  Logout,
  Settings as SettingsIcon,
  Contacts as ContactsIcon,
} from "@mui/icons-material";

function Header() {
  const navigate = useNavigate();
  const [, setCookie] = useCookies();
  const { userType, username, profilePicture } = useContext(UserContext);

  const handleLogout = () => {
    setCookie("auth_token", "", { path: "/", expires: new Date(0) });
    if (userType === "company") {
      navigate("/");
      navigate(0);
      return;
    }
    // Logout of CAS for students or admins
    const casClient = {
      // change when finished
      service_url: encodeURIComponent(
        "https://jobhub.cs.vt.edu/"
      ),
      server_url: "https://login.cs.vt.edu/cas/logout",
    };
    const homepage = window.location.origin.toString();
    const casLogoutUri = casClient.server_url + "?url=" + casClient.service_url;
    window.location.href = casLogoutUri;
    window.onload = function () {
      window.location.href = homepage;
    };
  };

  function horizontalLogo() {
    return (
      <div className="logo-container flex my-auto justify-center">
        <div className="display-logo flex justify-center">
          <a href="/">
            <img src={jobHubimg} alt="Job Hub" />
          </a>
        </div>
      </div>
    );
  }

  function homeButton() {
    return (
      <div className="Header-userProfile flex justify-center">
        <Link className="link-home ml-2" to="/">
          <Home className="home-icon" fontSize="small" />
          Home
        </Link>
      </div>
    );
  }

  function profileButton() {
    return (
      <div className="Header-userProfile flex justify-center">
        <Link className="link-profile ml-2 my-auto" to="/profile">
          <Person className="profile-icon" fontSize="small" />
          Profile
        </Link>
      </div>
    );
  }

  function settingsButton() {
    return (
      <div className="Header-userProfile flex justify-center">
        <Link className="link-settings ml-2 my-auto" to="/settings">
          <SettingsIcon className="settings-icon" fontSize="small" />
          Settings
        </Link>
      </div>
    );
  }
  function contactsButton() {
    return (
      <div className="Header-userProfile flex justify-center">
        <Link className="link-contacts ml-2" to="/contacts">
          <ContactsIcon className="contacts-icon" fontSize="small" />
          Contacts
        </Link>
      </div>
    );
  }
  function logoutButton() {
    return (
      <div className="Header-logout flex justify-center">
        <button
          type="button"
          className="logout-button my-auto capitalize decoration-none"
          onClick={handleLogout}>
          <Logout fontSize="small" className="logout-icon" />
          Logout
        </button>
      </div>
    );
  }

  function dropdown() {
    let itemArray = [];
    if (userType === "student") {
      itemArray = [
        {
          label: homeButton(),
          key: "0",
        },
        {
          type: "divider",
        },
        {
          label: profileButton(),
          key: "1",
        },
        {
          type: "divider",
        },
        {
          label: logoutButton(),
          key: "3",
        },
      ];
    } else if (userType === "company") {
      itemArray = [
        {
          label: homeButton(),
          key: "0",
        },
        {
          type: "divider",
        },
        {
          label: settingsButton(),
          key: "1",
        },
        {
          type: "divider",
        },
        {
          label: contactsButton(),
          key: "2",
        },
        {
          type: "divider",
        },
        {
          label: logoutButton(),
          key: "2",
        },
      ];
    } else {
      itemArray = [
        {
          label: homeButton(),
          key: "0",
        },
        {
          type: "divider",
        },
        {
          label: logoutButton(),
          key: "1",
        },
      ];
    }

    return (
      <div className="Header-buttonContainer flex my-auto">
        <Dropdown
          menu={{
            items: itemArray,
          }}
          trigger={["click"]}
          placement="bottom">
          <div className="Header-userProfileContainer flex w-40">
            <Avatar
              src={profilePicture}
              alt="User Icon"
              sx={{ width: 52, height: 52 }}
              className="Header-userProfileImage mr-4"
            />
            <div className="Header-userProfileRight font-brand-primary font-bold text-white">
              <div className="Header-userProfileName">{username}</div>
              <div className="Header-userProfileYear capitalize italic">
                {userType}
              </div>
            </div>
          </div>
        </Dropdown>
      </div>
    );
  }

  return (
    <div className="Header h-20 flex justify-between px-2 py-2 bg-brand-primary">
      <Logo className="VtLogo" />
      {(userType === "student" ||
        userType === "company" ||
        userType === "admin" ||
        userType === "faculty") &&
        horizontalLogo()}
      {(userType === "student" ||
        userType === "company" ||
        userType === "admin" ||
        userType === "faculty") &&
        dropdown()}
    </div>
  );
}

export default Header;
